import { CustomExportFileModel } from "../models";

export class GetKPIDetailExportViewModel {
    customExportFile: CustomExportFileModel = new CustomExportFileModel();
    KPIShipmentId: number;
    PageSize: number;
    PageNumber: number;
}